import { formatCloseTemplateDateRange } from "./formatCloseTemplateDateRange";

interface Props {
    startDate: string | null;
    endDate: string | null;
}

/**
 * Displays a date range for a close template application in the most compact
 * readable form possible:
 *
 * - Exact full year  → "2025"
 * - Exact quarter    → "Q1 2025"
 * - Exact full month → "January 2025"
 * - Any other range  → "Jan 1, 2025 – Dec 31, 2025"
 * - Both null        → "-"
 */
export const DateRangeDisplay = ({ startDate, endDate }: Props) => (
    <span>{formatCloseTemplateDateRange(startDate, endDate)}</span>
);
